<template>
  <div class="warning-type">
    <Card style="padding-bottom: 40px">
      <Button @click="addWarningType" type="primary">添加</Button>
      <Table
          :loading="WarningLoading"
          :columns="columns"
          :data="data"
          :border="true"
          :highlight-current-row="true"
          style="margin-top: 10px"
      >
        <template #action="{ row, index }">
          <el-button size="small" type="text" @click="getWarningTypeById(row)">编辑</el-button>
          <el-button size="small" type="text" @click="deleteWarningType(row)">删除</el-button>
        </template>
      </Table>
    </Card>
    <Modal v-model="warningTypeModal"
           :title="isEdit ? '修改' : '添加'"
    >
      <Form :model="warningTypeFrom" :rules="warningTypeRules" :label-width="100" ref="warningTypeFrom">
        <FormItem label="预警类型" prop="name">
          <Input v-model="warningTypeFrom.name"></Input>
        </FormItem>
      </Form>
      <template slot="footer">
        <Button @click="warningTypeModal = false">取消</Button>
        <Button v-if="!isEdit" type="primary" :loading="addLoading" @click="addWarning">确定</Button>
        <Button v-else type="primary" :loading="addLoading" @click="editWarning">修改</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "warningType",
  data() {
    return {
      warningTypeModal: false,
      WarningLoading: false,
      addLoading: false,
      isEdit: false,
      columns: [
        {
          title: 'id',
          key: 'id',
          align: 'center',
        },
        {
          title: '预警类型',
          key: 'name',
          align: 'center',
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
        }
      ],
      data: [],
      warningTypeFrom: {
        name: '',
      },
      warningTypeRules: {
        name: [
          { required: true, message: '请输入预警类型', trigger: 'blur' }
        ],
      },
    }
  },
  mounted() {
    this.getWarningType()
  },
  methods: {
    addWarning() {
      this.$refs.warningTypeFrom.validate((valid) => {
        if (valid) {
          this.addLoading = true
          this.$http.post('/api/earlyWarningTypes', this.warningTypeFrom).then(res => {
            this.addLoading = false
            this.warningTypeModal = false
            this.$Message.success('添加成功')
            this.getWarningType()
          })
        } else {
          return false
        }
      })
    },
    getWarningTypeById(row) {
      let id = row.id
      this.$http.get(`/api/earlyWarningTypes/${ id }`).then(res => {
        if (res.status === 200) {
          this.isEdit = true
          this.warningTypeFrom = res.data
          this.warningTypeModal = true
        } else {
          this.$Message.error('获取数据失败')
        }
      })
    },
    editWarning() {
      this.$refs.warningTypeFrom.validate((valid) => {
        if (valid) {
          this.addLoading = true
          let request = {
            ...this.warningTypeFrom
          }
          this.$http.put(`/api/earlyWarningTypes`, request).then(res => {
            if (res.status === 200) {
              this.addLoading = false
              this.warningTypeModal = false
              this.$Message.success('修改成功')
              this.getWarningType()
            } else {
              this.$Message.error('修改失败')
            }
          })
        } else {
          return false
        }
      })
    },
    addWarningType() {
      this.warningTypeModal = true
      this.isEdit = false
      this.$refs.warningTypeFrom.resetFields()
    },
    getWarningType() {
      this.$http.get('/api/earlyWarningTypes').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.data = res.data.data
        }
      })
    },
    deleteWarningType(row){
      this.$http.delete(`/api/earlyWarningTypes/${row.id}`).then(res => {
        console.log(res)
        this.getWarningType()
      })
    }
  }
}
</script>

<style scoped>

</style>
